import Loader from '@components/loader/loader.tsx';

function LoaderComponent() {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-xl font-bold text-gray-800">Loader</h2>
      <p className="text-sm text-gray-400">
        The app's standard loading spinner.
      </p>
      <div className="w-full p-20 flex items-center justify-center border border-gray-100 rounded-xl bg-white">
        <Loader />
      </div>
    </div>
  );
}

export default LoaderComponent;
